import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  baseUrl!: string;
  http = inject(HttpClient);

  getAll(params: any = {}) {
    let httpParams = new HttpParams();

    for (const key in params) {
      if (params[key]) {
        httpParams = httpParams.set(key, params[key]);
      }
    }

    return this.http.get<any>(this.baseUrl, { params: httpParams });
  }

  get(id: string | number) {
    return this.http.get<any>(`${this.baseUrl}/${id}`);
  }

  create(body: any) {
    return this.http.post<any>(this.baseUrl, body);
  }

  update(id: string | number, body: any) {
    return this.http.put<any>(`${this.baseUrl}/${id}`, body);
  }

  delete(id: string | number) {
    return this.http.delete<any>(`${this.baseUrl}/${id}`);
  }
}
